var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgGithubWithCircle = function SvgGithubWithCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "github-with-circle_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0.4c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6s9.6-4.3,9.6-9.6S15.3,0.4,10,0.4z M11,14.7c-0.2,0-0.6,0-1,0 c-0.4,0-0.8,0-1,0c-0.9,0-4.5-0.1-4.5-4.4c0-1,0.3-1.7,0.9-2.3C5.3,7.8,5.3,6.5,5.8,5.3c0,0,1.1,0.1,2.7,1.2C8.8,6.5,9.4,6.4,10,6.4 c0.6,0,1.2,0,1.5,0.1c1.6-1.1,2.7-1.2,2.7-1.2c0.5,1.2,0.5,2.4,0.4,2.6c0.6,0.6,0.9,1.3,0.9,2.3C15.5,14.6,11.9,14.7,11,14.7z  M10,9.9C10,9.9,10,9.9,10,9.9L10,9.9c-1.4,0-2.7-0.4-3.4,0.3C6.2,10.7,6,11.1,6,11.7c0,2.2,1.8,2.5,4,2.5h0c2.3,0,4-0.3,4-2.5 c0-0.5-0.2-1-0.6-1.4C12.7,9.6,11.4,9.9,10,9.9z M8.1,12.9c-0.4,0-0.8-0.5-0.8-1.1c0-0.6,0.3-1.1,0.8-1.1c0.4,0,0.8,0.5,0.8,1.1 C8.9,12.5,8.5,12.9,8.1,12.9z M11.9,12.9c-0.4,0-0.8-0.5-0.8-1.1c0-0.6,0.3-1.1,0.8-1.1c0.4,0,0.8,0.5,0.8,1.1 C12.7,12.5,12.3,12.9,11.9,12.9z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgGithubWithCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/github-with-circle.217c4b52b925b8975b5bb60692e4aa75.svg";